import { useQuestCompletions } from "@/components/QuestsV2/useQuestCompletions";
import { IMMUTABLE_GAME_ID, ONBOARDING_QUEST_ID } from "@/constants";
import { useMemo } from "react";

export const useIsOnboardingCompleted = () => {
  const { completedQuests, error, isLoading, mutate } =
    useQuestCompletions(IMMUTABLE_GAME_ID);

  const isOnboardingCompleted = useMemo(() => {
    if (!completedQuests) return;
    return Object.keys(completedQuests).includes(
      ONBOARDING_QUEST_ID.replace("-event", ""),
    );
  }, [completedQuests]);

  return { isOnboardingCompleted, error, isLoading, mutate };
};
